import { Box, Avatar, Typography } from '@material-ui/core'
import { Notification } from 'common/types/notification.types'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useAnalytics } from 'hooks/use-analytics/useAnalytics'
import { Button } from 'common/atoms/Button/Button'

interface NotificationDetailsProps {
  action: string
  notification: Notification
  updateNotification: Function
  setDrawer: Function
  theme: any
  setNotifications: Function
  notifications: Notification[]
  setTotalNotifications: Function
  totalNotifications: number
  viewNotification: Function
  getDataFromMessage: Function
}

const StyledBox = styled(Box)`
  && {
    width: 100%;
    display: flex;
    padding: 1em 0;
  }
`

const StyledTime = styled(Box)`
  && {
    color: ${props => props.theme.colors.accent};
    &:after {
      content: '';
      display: block;
      width: 10%;
      padding-top: 0.5em;
      border-bottom: 2px solid ${props => props.theme.colors.primary};
    }
  }
`

export const NotificationDetails: FunctionComponent<NotificationDetailsProps> = ({
  action,
  notification,
  theme,
  updateNotification,
  notifications,
  setDrawer,
  setNotifications,
  setTotalNotifications,
  totalNotifications,
  viewNotification,
  getDataFromMessage
}) => {
  const history = useHistory()
  const { backendPartner, backendUser } = useAuth()
  const { logEventAnalytics } = useAnalytics()

  const handleSubmit = e => {
    e.preventDefault()
    setDrawer(false)
    updateNotification(notification?.id)
    setTotalNotifications(totalNotifications - 1)
    setNotifications(notifications.filter(current => current.id !== notification.id))
    viewNotification(notification)
  }

  const getName = (): string => {
    if (notification?.sender?.companyName) {
      return notification?.sender?.companyName === 'Obsidi' ? '' : notification?.sender?.companyName
    } else {
      return `${notification?.sender?.firstName} ${notification?.sender?.lastName}`
    }
  }

  const handleLogoClick = () => {
    const partnerLog = {}
    const userLog = {}

    if (backendUser?.partnerId) {
      partnerLog['Partner ID'] = backendPartner?.id
      partnerLog['Company Name'] = backendPartner?.name
      partnerLog['Account Type'] = 'Partner'
    } else {
      userLog['Account Type'] = backendUser?.role
    }

    logEventAnalytics(
      backendUser?.partnerId ? 'Partner' : backendUser?.role,
      'Profile viewed',
      'mixpanel',
      'Profile viewed',
      {
        'Member profile viewed': notification?.sender?.id,
        'User ID': backendUser?.id,
        'From post': false,
        'From chat': false,
        'From managed connections': false,
        'From pings': true,
        'From suggested connections': false,
        ...partnerLog,
        ...userLog
      },
      backendUser?.id,
      {
        $name: `${backendUser?.firstName} ${backendUser?.lastName}`,
        $email: backendUser?.username
      }
    )
    if (notification?.sender?.companyName === 'Obsidi') {
      return
    } else if (notification?.sender?.partnerId) {
      history.push(`/company/${notification?.sender?.partnerId}`)
    } else {
      history.push(`/profile/${notification?.sender?.id}`)
    }
  }

  return (
    <StyledBox>
      <Box marginRight="1em" onClick={() => handleLogoClick()} style={{ cursor: 'pointer' }} height="min-content">
        <Avatar src={notification?.sender?.avatar} />
      </Box>
      <Box
        style={{ cursor: 'pointer' }}
        width="100%"
        onClick={e => {
          handleSubmit(e)
        }}
      >
        <Box display="flex" gridGap={10} width="100%">
          <Box color={theme.colors.accent1} width="100%">
            <Typography component="span" variant="body2">
              <Box fontWeight="700" display="inline">
                {getName()}
              </Box>
            </Typography>{' '}
            <Typography variant="body2" component="span">
              {`${getDataFromMessage(notification?.description, 'message')}`}
            </Typography>
          </Box>
          <Box width="45%">
            <Button
              design="primary"
              small
              fullWidth
              onClick={e => {
                handleSubmit(e)
              }}
            >
              {action}
            </Button>
          </Box>
        </Box>
        <StyledTime>
          <Typography variant="body2">{moment(notification?.createdAt).fromNow()}</Typography>
        </StyledTime>
      </Box>
    </StyledBox>
  )
}
